export default function () {
    return (
        <svg width="36" height="37" viewBox="0 0 36 37" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_1975_20687)">
                <path d="M6.75 6.125V11.75" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M6.75 7.25H12.375" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M6.75 10.625H12.375" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M29.25 11.8105L29.25 6.125" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M29.25 10.625H23.625" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M29.25 7.25H23.625" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M16.1602 7.55908V11.8104" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M19.8398 7.55908V11.8104" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.875 24.125H19.125V17.375H16.875V24.125Z"
                    stroke="black"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.875 30.875C16.875 31.4963 17.3787 32 18 32C18.6213 32 19.125 31.4963 19.125 30.875V24.125H16.875V30.875Z"
                    fill="black"
                />
                <path
                    d="M26.4988 23.9351L23.3101 27.1238L24.5838 28.3974L21.7656 31.2162"
                    stroke="black"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9.55078 23.6885L12.7395 26.8767L11.4659 28.1509L14.2846 30.9696"
                    stroke="black"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.375 5.5625C12.375 5.25184 12.6268 5 12.9375 5H23.0625C23.3732 5 23.625 5.25184 23.625 5.5625V13.0048C23.625 13.3155 23.3731 13.5673 23.0624 13.5673C22.4593 13.5673 21.9782 13.5673 21.3751 13.5673C21.0644 13.5673 20.8125 13.8191 20.8125 14.1298V16.8125C20.8125 17.1232 20.5607 17.375 20.25 17.375H15.75C15.4393 17.375 15.1875 17.1232 15.1875 16.8125V14.1298C15.1875 13.8191 14.9357 13.5673 14.625 13.5673H12.9375C12.6268 13.5673 12.375 13.3155 12.375 13.0048V5.5625Z"
                    stroke="black"
                    strokeWidth="1.5"
                />
            </g>
            <defs>
                <clipPath id="clip0_1975_20687">
                    <rect width="36" height="36" fill="white" transform="translate(0 0.5)" />
                </clipPath>
            </defs>
        </svg>
    );
}
